import { AddressType } from '@marriott/mi-groups-graphql';

export const ContactInfoSummaryAemMock = {
  title: 'Contact Information',
  contact: 'CONTACT',
  phoneAndEmail: 'PHONE AND EMAIL',
  companyName: 'COMPANY NAME',
  typeOfAccount: 'TYPE OF ACCOUNT',
  personal: 'Personal',
  business: 'Business',
  address: 'ADDRESS',
  accountRepresentativeName: 'MARRIOTT REPRESENTATIVE NAME',
  accountRepresentativeEmail: 'MARRIOTT REPRESENTATIVE EMAIL',
  additionalInformation: 'Additional Information',
};

export const ContactInfoSummaryDataMock = {
  userInfo: {
    firstName: 'Shahil',
    lastName: 'Subham',
    email: 'shahil@gmail.com',
    callingCode: {
      label: 'India <span>+91</span>',
      value: '+91',
      __typename: 'Lookup',
      code: '91',
      description: 'India',
      shortDescription: 'IN',
    },
    phoneNumber: '9916793491',
    rewardId: '',
  },
  addressInfo: {
    addressType: AddressType.BUSINESS,
    companyName: 'Sapient',
    addressLine1: 'Bangmane',
    addressLine2: 'Tech Park',
    country: {
      label: 'India',
      value: 'India',
      __typename: 'Lookup',
      code: 'IN',
      description: 'India',
    },
    city: 'Bengaluru',
    state: 'Patna',
    zipcode: '560098',
  },
};

export const ContactInfoSummaryMock = {
  labels: { ...ContactInfoSummaryAemMock },
  data: {
    ...ContactInfoSummaryDataMock,
    inlineEnrolment: {
      joinMarriottBonvoy: false,
      createPassword: '',
      confirmPassword: '',
      rememberMe: false,
      receiveUpdates: false,
      receiveOffers: false,
    },
    additionalInfo: 'slkfhskdfsjfksdjfsdkmfl',
    gsoInfo: {
      name: 'Devinder',
      email: 'devinder@marriott.com',
    },
  },
};

export const ContactInfoSummaryPartialMock = {
  labels: { ...ContactInfoSummaryAemMock },
  data: {
    userInfo: {
      firstName: 'Shahil',
      lastName: 'Subham',
      email: 'shahil@gmail.com',
      callingCode: {
        label: 'India <span>+91</span>',
        value: '+91',
        __typename: 'Lookup',
        code: '91',
        description: 'India',
        shortDescription: 'IN',
      },
      phoneNumber: '9916793491',
      rewardId: '',
    },
    inlineEnrolment: {
      joinMarriottBonvoy: false,
      createPassword: '',
      confirmPassword: '',
      rememberMe: false,
      receiveUpdates: false,
      receiveOffers: false,
    },
    addressInfo: {
      addressType: AddressType.PERSONAL,
      companyName: '',
      addressLine1: 'Bagmane',
      addressLine2: 'Tech Park',
      country: {
        label: 'India',
        value: 'India',
        __typename: 'Lookup',
        code: 'IN',
        description: 'India',
      },
      city: 'Bengaluru',
      state: 'Karnataka',
      zipcode: '560098',
    },
    additionalInfo: '',
    gsoInfo: {
      name: '',
      email: '',
    },
  },
};
